import { __ } from "@wordpress/i18n";
import React from 'react';
import MediaUploader from '../components/MediaUploader/MediaUploader';
import { useMenu } from "../contexts/MenuContext";
import withForm from '../pages/withForm';
const RestrictionsCustomize = ({handleChange}) => {
    const {
        settingData, 
    } = useMenu();
    const options = settingData?.restrictions?.customize;

    
    return (
        <>
            <div className="setting-unit">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Header background image", "ultimate-security")}</h5>                         
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">                                
                                <MediaUploader 
                                    data={settingData?.restrictions?.customize?.['header_background_image']} 
                                    name='restrictions.customize.header_background_image' 
                                    handleChange={handleChange}
                                    options = {{
                                        frame:{
                                            title: __("Select or Upload Image", "ultimate-security"),
                                        },
                                        library: {type: 'image'},
                                        buttons: {
                                            upload: __("Upload Image", "ultimate-security"),
                                            remove: __("Remove", "ultimate-security"),
                                            select: __("Use this image", "ultimate-security")                                            
                                        },
                                        hint: __("No Hint", "ultimate-security"),
                                        message: {
                                            size: 'Size: Optional <br> File Support: jpg, .jpeg, . gif, or .png.',
                                            info: 'Select the background image for the header'
                                        } 
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div> 
        </>
    )
}
export default withForm(RestrictionsCustomize, 'restrictions.customize');